import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { config as CONFIG } from "app/app.config";

@Component({
    selector: "app-star-rating",
    templateUrl: "./star-rating.component.html",
    styleUrls: ["./star-rating.component.scss"],
})
export class StarRatingComponent implements OnInit {
    @Input() rutContratista: number = 0;
    @Input() cantidadEstrellas: number = 5;
    @Input() evaluacion: number = -1;
    @Input() seteable: boolean = false;
    @Output() evaluacionEvent: EventEmitter<number> = new EventEmitter();
    config = CONFIG;
    estrellas: number[] = [];
    posicionAMedioPintar: number;
    pintarUnTercio = false;
    pintarDosTercios = false;
    pintarMitad = false;

    constructor() {}

    ngOnInit(): void {
        this.evaluacionEvent.emit(this.evaluacion);
        //console.log(this.evaluacion);
        for (let index = 1; index <= this.cantidadEstrellas; index++) {
            this.estrellas.push(index);
        }

        if (this.isFloat()) {
            //console.log("entro");
            this.calculaPosicionAMedioPintar();
        }
    }

    calculaPosicionAMedioPintar() {
        let posicion = 0;

        for (let index = 0; index < this.estrellas.length; index++) {
            if (
                this.estrellas[index] > this.evaluacion //* this.cantidadEstrellas
            ) {
                posicion = index;
                break;
            }
        }
        this.posicionAMedioPintar = posicion;
        const decimal = this.obtieneSegundoDecimal();
        //console.log("decimal", decimal);
        //console.log(decimal === this.cantidadEstrellas);
        if (decimal || decimal === 0) {
            if (decimal < this.cantidadEstrellas) {
                this.pintarUnTercio = true;
            } else if (decimal === this.cantidadEstrellas) {
                this.pintarMitad = true;
            } else if (decimal > this.cantidadEstrellas) {
                this.pintarDosTercios = true;
            }
        } else {
            this.pintarMitad = true;
        }
    }

    isFloat(): boolean {
        const valor = this.evaluacion; // * this.cantidadEstrellas;

        return Number(valor) === valor && valor % 1 !== 0;
    }

    obtieneSegundoDecimal(): number {
        if (!Number.isInteger(this.evaluacion)) {
            // * this.cantidadEstrellas)) {
            return parseFloat(
                this.evaluacion //* this.cantidadEstrellas)
                    .toString()
                    .split(".")[1][0]
            );
        }
        return null;
    }

    addClass(estrella: number) {
        if (this.seteable) {
            let ab = "";
            for (let i = 0; i < estrella; i++) {
                // console.log("estrella i", estrella);
                ab = this.rutContratista + "estrellaId" + i;
                this.removeClasesExtras(ab);
                document.getElementById(ab).classList.remove("primary-A100-fg");
                document.getElementById(ab).classList.add("yellow-700-fg");
            }
        }
    }
    removeClass(estrella: number) {
        if (this.seteable) {
            let ab = "";
            for (
                let i = estrella - 1;
                i >= (this.evaluacion === -1 ? 0 : this.evaluacion);
                i--
            ) {
                //                console.log("star i", estrella);
                ab = this.rutContratista + "estrellaId" + i;
                this.removeClasesExtras(ab);
                document.getElementById(ab).classList.remove("yellow-700-fg");

                document.getElementById(ab).classList.add("primary-A100-fg");
            }
        }
    }

    countStar(estrella: number) {
        if (this.seteable) {
            if (estrella === 1 && this.evaluacion === 1) {
                this.evaluacion = 0;
            } else {
                this.evaluacion = estrella;
            }
            this.evaluacionEvent.emit(this.evaluacion);
        }
    }

    removeClasesExtras(ab: string) {
        document.getElementById(ab).classList.remove("paint-half");
        document.getElementById(ab).classList.remove("paint-one-third");
        document.getElementById(ab).classList.remove("paint-two-third");
    }
}
